import { render, staticRenderFns } from "./FormAccordiant.vue?vue&type=template&id=5454dc4a"
import script from "./FormAccordiant.vue?vue&type=script&lang=js"
export * from "./FormAccordiant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports